import { Trans } from '@lingui/react/macro'


import { cls } from 'tagged-classnames-free';
import { CssIcon } from '@/components/CssIcon';
interface EmptyDataProps {
  listType?: string
}

export const EmptyData: React.FC<EmptyDataProps> = (props) => {
  const { listType } = props

  return (
    <div
      className={cls`my-auto flex w-full flex-col items-center justify-center`}
    >
      <CssIcon className='i-cus--tad-loading-02 size-[120px]' />
      <div className={cls`text-f-text-secondary mt-2 text-center text-sm`}>
        {listType === 'liked' ? (
          <Trans>Your liked music will appear here.</Trans>
        ) : (
          <Trans>Your generated audio will appear here.</Trans>
        )}
      </div>
    </div>
  )
}
